<template>
  <div>
    <div>
      <label>Email: </label><span>{{getUserProfile.email}}</span>
    </div>
    <div>
      <label>Roles: </label>
      <span v-if="getUserProfile.roles" v-for="role in getUserProfile.roles">{{role}}</span>
      <span v-else>None</span>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'smex-info',
    computed: {
      ...mapGetters(['getUserProfile'])
    }
  }
</script>

<style scoped>

</style>
